export const routes = {
  start: "/",
  recommendation: "/recommendation",
  search: "/search",
  selectedResources: "/selected-resources",
  attendees: "/attendees",
  setting: "/setting",
  changeTime: "/change-time",
  findColleague: "/find-colleague",
  findFavorite: "/find-favorite",
  quickSearch: "/quick-search",
  agent: "/agent",
  testAuth: "/test-auth",
};

// export const routes = [
//   {
//     name: "Start",
//     path: "/",
//     element:<Start />
//   },
//   {
//     name: "Recommendation",
//     path: "/recommendation",
//     element:<Recommendation />
//   },
// ] as const;

// type RouteName = (typeof routes)[number]["name"];

// type RoutesMap = {
//   [K in RouteName]: (typeof routes)[number]["path"];
// };

// export const routesMap = ((): RoutesMap => {
//   return routes.reduce((acc, route) => {
//     acc[route.name] = route.path;
//     return acc;
//   }, {} as RoutesMap);
// })();
